import { Pipe, PipeTransform } from '@angular/core';
import { CustomerAddress } from '../models/customer-address';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(addr: CustomerAddress, args?: any): string {
    if(addr) {
      return addr.name + ': ' + addr.street + ', ' + addr.colony + ', ' + addr.city + ', C.P.: ' + addr.zip_code + ', ' + addr.locality + ', ' + addr.state;
    } else {
      return "";
    }
  }

}
